import ShareThis from "@/components/elements/ShareThis";
import { ArticleSchema } from "@roc-digital/mxm-base/dist/data";
import { Modal } from '@roc-digital/ui-web';

export function shareArticle(article: ArticleSchema) {
  Modal.open('mxm.modal', <ShareThis article={article} />, 'small');
}